import { Chantier } from './json-interface';
import { Subject } from 'rxjs';
import { LoggedUserService } from '../services/loged-user/loged-user.service';
import { g_params } from './global-param';
import {ArmaServServerMethods} from './ArmaServServerMethods';

export class InitApp {

  /**
   * Appeler dans le app.compoents.ts
   * Met en memoire tout ce qui est imporant pour l'execution du programme
   * @param armaservMethod Liste des méthode disponible pour l'api d'armaserv
   * @param loggedUserService ??
   * @param subject ??
   */
   public static async initAll(armaservMethod: ArmaServServerMethods,
                               loggedUserService: LoggedUserService,
                               subject?: Subject<string>) {
    subject?.next('Init data');
    // Stock la liste des chantier dans le gparam
    await this.refreshArraySite(armaservMethod);

    // Recuperation de la liste des parametre qui vont étre utilisé pour le web
    await this.initGParam(armaservMethod);

    subject?.next('Done');
    await loggedUserService.loadFromServer();
    subject?.complete();
  }

  public static async refreshArraySite(armaservMethod: ArmaServServerMethods): Promise<Chantier[]> {
      g_params.g_arraySite = await armaservMethod.getListSite();
      return g_params.g_arraySite;
  }

  private static async initGParam(armaservMethod: ArmaServServerMethods) {
    const webServerParameter = await armaservMethod.loadGParam();
    // Affectation
    g_params.OPT_WMESH = webServerParameter.OPT_WMESH;
    g_params.g_factoryName = webServerParameter.FACTORY_NAME;
    g_params.shapeCode99 = webServerParameter.SHAPE_99;
    g_params.measureUnitStr = webServerParameter.UNIT_USED;
    g_params.useJoiningCode = webServerParameter.USE_JOINING_CODE;
    g_params.nbMinMesh = webServerParameter.NB_MIN_MESH;
    g_params.inputSteelAndProduct = webServerParameter.INPUT_STEEL_AND_PRODUCT;
    g_params.unitDimPlaqueMesh = webServerParameter.UNIT_DIM_PLAQUE_MESH;
    g_params.minOpenDateBetweenCreateAndDelivery = webServerParameter.WEB_MIN_OPEN_DATE_BETWEEN_CREATE_AND_DELIVERY;
  }
}
